<template>
    <v-dialog v-model="modal" :transition="fullscreen?'dialog-bottom-transition':'dialog-transition'" persistent :fullscreen="fullscreen" :width="width" scrollable>
        <v-card class="fondo-curso-modal">
            <v-toolbar class="cerrar" :height="heightCerrar" :color="colorSuperior">
                <v-spacer> </v-spacer>
                <button v-if="mostrarCerrar" @click="$emit('click', false), $emit('pausarAudio')" class="hvr hvr-scale">
                    <v-icon color="#FFFFFF">close</v-icon>
                </button>
            </v-toolbar>
            <v-card-text class="pa-2 ma-0" style="overflow:hidden;">
                <slot name="modalcontent"></slot>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
    export default {
        model: {
            prop: 'modal',
            event: 'click'
        },
        props: {
            modal: Boolean,
            width: {
                type: String,
                default: '90vw'
            },
            fullscreen: {
                type: Boolean,
                default: true,
            },
            mostrarCerrar: {
                type: Boolean,
                default: true
            },
            heightCerrar:{
                type: String,
                default: '45px'
            },
            colorSuperior:{
                type: String,
                default: 'success'
            }
        },
        data() {
            return {
                dataTrivia:{
                    barrioId:1,
                    contentId:2,
                    titulo:'Trivia',
                    descripcion:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga ipsum odio assumenda et labore omnis inventore ullam, optio facilis eligendi ab veniam minus accusantium natus pariatur. Perspiciatis blanditiis id quia.',
                    trivia: {
                        drags:[
                            '¿Cuál fue la percepción de Sayda Palma durante la inundación?',
                            '¿Por qué Propicia 2 es un barrio de riesgo alto en inundaciones?',
                            '¿Por qué Flor Tigasi considera que se deben aprender temas de medio ambiente y calentamiento global? '
                        ],
                        drops:[
                            'Al comienzo no entendía la situación ni el porqué de las cosas sin embargo una persona mayor le dijo que el agua subiría hasta su ventana y a partir de allí pidió auxilio para poder albergarse en otro lado. A partir de ese momento entendió que debemos estar preparados y capacitar a las demás generaciones.',
                            'Debido a que la confluencia de factores como intensas precipitaciones en la cuenca alta del Río Esmeraldas y en la cuenca alta del Río Teaone,  está en una ubicación de alto riesgo de inundación.',
                            'La contaminación, la basura en las calles no permiten llevar bien el ecosistema por lo que es importante tener conciencia, cuidar nuestro planeta y pensar que le vamos a dejar a nuestros hijos.'
                        ]
                    },
                    opciones:[
                        {
                            contentId:'',
                            drag:'',
                            drop:''
                        },
                        {
                            drag:'',
                            drop:''
                        },
                        {
                            drag:'',
                            drop:''
                        },
                    ]
                }
            }
        },
        watch: {
            fullscreen: function(value){
                if(value){

                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../scss/helpers/variables';
    
    .cerrar {
        padding-bottom: 0;
        text-align: center;
        background: #0B542D!important;
        box-shadow: none;
        flex: none;
        font-size: 1em!important;
        img{
            width: 30px;
        }
        h2{
            color: #FFFFFF;
        }

    }

    .dialog-content {
        max-width: 100%;
        margin:0 auto;
        font-size: 1rem;
        padding: 0px;
        margin-top: 0px;
        align-items: center;
        @media (max-height: 800px){
            align-items: start;
        }
    }

    .fullscreen {
        @media (min-height: 800px){
            height: 70vh;
        }
    }
    .fondo-curso-modal {
        background: #FFFFFF;
        border-radius: 7px;
    }
</style>
